module.exports = __webpack_public_path__ + "assets/img/CMTP-Website.f05c01d6.jpg";